import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class FacilitiesApi {
  static getFacilities = ({ facility = true, search, organizationId } = {}) => {
    const params = new URLSearchParams();
    params.append('facility', facility);
    if (search && search.trim()) {
      params.append('search', btoa(search.trim()));
    }
    if (organizationId) {
      params.append('organizationId', organizationId);
    }

    return axios.get(`${API_BASE_URL}/facilities?${params.toString()}`);
  };

  static updateStatus = (id) => {
    return axios.get(`${API_BASE_URL}/updatestatus/${id}`);
  };

  static deleteFacility = (id) => {
    return axios.delete(`${API_BASE_URL}/delete_facility/${id}`);
  };

  static pullFilesFromSftp = (id) => {
    return axios.get(`${API_BASE_URL}/getFilesFromSftp/${id}`);
  };

  static getFacilitiesForForms = async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.organizationId) {
      queryParams.append('organizationId', params.organizationId);
    }

    const queryString = queryParams.toString();
    return (
      await axios.get(
        `${API_BASE_URL}/facilities/for-forms${
          queryString ? `?${queryString}` : ''
        }`,
      )
    ).data?.facilities;
  };

  static getAllFacilitiesPro = async () => {
    const limit = 100;
    const facilities = [];
    let page = 1;
    let hasMore = true;

    while (hasMore) {
      const response = await axios.get(
        `${API_BASE_URL}/facilitiesPro?page=${page}&limit=${limit}`,
      );
      facilities.push(...response.data);
      hasMore = response.data.length === limit;
      page += 1;
    }

    return facilities;
  };

  static getAllowedAttachmentTypes = (facilityId) => {
    const reqFacilityId = facilityId;

    if (!reqFacilityId) {
      throw new Error('Facility ID is required');
    }

    return axios.get(
      API_BASE_URL +
        `/facilities/${reqFacilityId}/allowed-refund-attachment-types`,
    );
  };
}
